<template>
  <main>
    <BlokkliProvider
      v-slot="{ entity, isEditing }"
      v-bind="blokkliProps"
      :entity="props"
    >
      <PageHero
        v-if="heroMedia"
        :title="title"
        :subtitle="lead"
        :media="heroMedia"
      />
      <PageHeader
        v-else-if="!headerHidden"
        :title="entity.title"
        :subtitle="entity.lead"
      />
      <BlokkliField
        :list="filterNullArray(paragraphs)"
        name="field_paragraphs"
        :should-render-item
        :allowed-fragments
      />
      <slot :is-editing="isEditing" />
    </BlokkliProvider>
    <SharingButtons v-if="showSharing" />
  </main>
</template>

<script lang="ts" setup>
import type { BlokkliFragmentName } from '#blokkli-build/definitions'
import { DomainId, type NodeEditorialFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

const props = defineProps<NodeEditorialFragment>()

const { activeDomain } = useSiteContext()

const { shouldRenderItem } = useParagraphVisiblity()

const headerHidden = computed(
  () => props.isFrontPage || props.isChannelLandingPage,
)

const allowedFragments = computed(() => {
  const fragments: BlokkliFragmentName[] = [
    'anchor_navigation',
    'zurich_card_widget',
    'countdown',
    'tomas_shop',
    'tours_search_form',
  ]

  // Only available on these two domains.
  if (
    activeDomain === DomainId.eyz ||
    activeDomain === DomainId.rapperswil_zuerichsee_ch
  ) {
    fragments.push('mailchimp_signup_form')
  }

  return fragments
})

useServerHead({
  script: props.hideUsercentrics
    ? [
        {
          key: 'usercentrics-hide',
          innerHTML: `var UC_UI_SUPPRESS_CMP_DISPLAY = true;`,
          tagPriority: -9999,
        },
      ]
    : undefined,
})

const schemaOrg = computed(() => {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
      },
    ],
  }
})

useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schemaOrg.value),
    },
  ],
})

const heroMedia = computed(() => props.keyVisualMedia)
</script>
